import styled from 'styled-components';

import Link from '~/src/common/components/Link';
import { COLORS } from '~/src/common/theme';

/** Container global */
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0;
`;

/** Titre de la section */
export const Title = styled.h4`
  margin: 0;
  padding: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
`;

/** Liste des mots clés */
export const Entries = styled.div`
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  margin: 0;
  gap: 8px;
`;

/** Lien pour un mot clé */
export const Entry = styled(Link)`
  padding: 4px 8px;
  border-radius: 4px;
  background: ${COLORS.GROUND_UNDERGROUND};
  color: ${COLORS.NEUTRAL_DEFAULT};

  font-size: 14px;
  font-weight: 700;
  line-height: 24px;
`;
